import React from 'react';

export default function BrandLogo({ size = "md", className = "" }) {
  const dimensions = {
    sm: "h-6",
    md: "h-10",
    lg: "h-16"
  };

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div className={`${dimensions[size]} aspect-square relative group`}>
        {/* Outer Ring */}
        <div className="absolute inset-0 border-2 border-bb-gold/30 rounded-lg rotate-45 group-hover:rotate-90 transition-transform duration-700"></div>
        {/* Inner Beam Rail */}
        <div className="absolute inset-[15%] border border-bb-accent/40 rounded-sm -rotate-12 group-hover:rotate-0 transition-transform duration-500"></div>
        {/* Core Light Source */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-1.5 h-1.5 bg-white rounded-full shadow-[0_0_12px_#fff,0_0_20px_#D4AF37]"></div>
          {/* Vertical Beam */}
          <div className="absolute w-[1px] h-[80%] bg-gradient-to-t from-transparent via-bb-gold to-transparent opacity-80"></div>
          {/* Horizontal Rail */}
          <div className="absolute h-[1px] w-[80%] bg-gradient-to-r from-transparent via-bb-accent to-transparent opacity-60"></div>
        </div>
      </div>
      {size !== "sm" && (
        <span className={`font-bold tracking-tighter text-white ${size === 'lg' ? 'text-3xl' : 'text-xl'}`}>
          Budget<span className="text-bb-gold">Beam</span>
        </span>
      )}
    </div>
  );
}